import { FC } from 'react';
import { Tr } from '@utils';
import { Box, Button, Card, CardProps, Stack, Typography } from '@mui/material';
import { ReactComponent as Illustration } from '@assets/illustrations/need-help.svg';

export interface IWideNeedHelpCardProps extends CardProps {
	onContactUsClicked?: () => void;
}

export const WideNeedHelpCard: FC<IWideNeedHelpCardProps> = ({ onContactUsClicked, sx, ...props }) => {
	return (
		<Card
			variant="outlined"
			sx={{
				borderRadius: 8,
				width: 1.0,
				backgroundColor: 'common.black',
				color: 'common.white',
				paddingX: 5,
				paddingY: 2,
				...sx
			}}
			{...props}
		>
			<Stack direction="row" spacing={5} alignItems="center" justifyContent="space-between">
				<Box sx={{ width: 70, height: 75, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
					<Illustration />
				</Box>
				<Stack direction="column" spacing={1}>
					<Typography variant="h5">
						<Tr.Portal path="dashboard.need-help-title" />
					</Typography>
					<Typography>
						<Tr.Portal path="dashboard.need-help-content" />
					</Typography>
				</Stack>
				<Button
					variant="outlined"
					color="secondary"
					sx={{
						minWidth: 160,
						border: 'solid 2px #fff',
						color: '#fff',
						'&:hover': {
							border: 'solid 2px #fff'
						}
					}}
					onClick={onContactUsClicked}
					data-testid="need-help-button"
				>
					<Tr.Portal path="dashboard.contact-us-button" />
				</Button>
			</Stack>
		</Card>
	);
};
